import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative aspect-122/72 cursor-pointer max-md:w-full',
    imageWrapper: 'relative size-full overflow-hidden',
    image: 'rounded-[6px] object-cover',
    logo: 'absolute top-1/2 left-1/2 z-1 -translate-x-1/2 -translate-y-1/2'
  },
  variants: {
    selected: {
      true: {
        base: 'p-1 before:absolute before:inset-0 before:-m-0.5 before:rounded-[6px] before:border-2 before:border-black before:content-[""]'
      }
    }
  }
});
